import * as React from 'react'
import { connect } from 'react-redux'
import { spacerAlignItems, Spacer, Spacing } from 'DVWebNodeUI'
import { PlaybackMessaging } from '../../components/playbackMessaging/playbackMessaging'
import { Refund } from '../../components/refund/refund'
import { TextBlockNotification } from '../../components/notificationAction/notificationAction'
import { Trailer } from '../../components/playback/trailer'
import { Watchlist } from '../../components/watchlist/watchlist'
import { DisneyAction } from '../../components/disneyAction/disneyAction'
import { RedeemAndPromoLink } from '../../components/redeemAndPromoLink/redeemAndPromoLink'
import { SecondaryOfferMessage } from '../../components/secondaryOfferMesssage/secondaryOfferMessage'
import { Acquisition } from '../../components/acquisition/acquisition'
import { AtfMorePurchaseOptions } from '../../components/morePurchaseOptions/atfMorePurchaseOptions'
import { MultiplePlayback } from '../../components/playback/multiplePlayback'
import { TvodButtonScope } from '../../components/acquisition/tvodButton'
import { AgeVerification } from '../../components/ageVerification/ageVerification'
import { TransactionOverlay } from '../../components/actionBox/disableOverlay'
import { IDetailPageState } from '../../reducers'
import { ActionBoxState } from '../../reducers/actionBox'
import {
  playbackMessagingComponentSelector,
  notificationActionsTextBlockMessagesSelector,
  trailerComponentSelector,
  purchaseComponentSelector,
  disneyComponentSelector,
  mwtwComponentSelector,
  secondaryOfferMessageComponentSelector,
  ageVerificationSelector,
  multiplePlaybackComponentSelector,
  downloadComponentSelector
} from '../../selectors/component/actionBoxComponentSelectors'
import { purchaseSelector } from '../../selectors/purchase'
import { isDeeplinkableActionReadySelector } from '../../selectors/pageContext'
import * as st from '../../components/actionBox/actionBox.module.scss'
import * as cn from 'classnames'
import { AdjustHeightForContent } from '../../utils/AdjustHeightForContent'
import { PurchaseFailedModal } from '../../components/actionBox/purchaseFailedModal'
import { DownloadAction, DownloadStatus, DownloadButtonWithLabel } from '@shared'
import { simpleSelectors } from '../../selectors/basicState'
import { GiftCardModal } from '../../components/giftCard/giftCardModal'
import { sanitizedRequestContextSelector } from '../../selectors/requestContext'

type ActionBoxComponentProps = ReturnType<typeof mapStateToProps>

export interface ActionBoxComponentState {
  giftCardModalIsVisible: boolean
}

export class ActionBoxComponent extends React.Component<ActionBoxComponentProps, ActionBoxComponentState> {

  constructor(props: ActionBoxComponentProps) {
    super(props)
    this.state = { giftCardModalIsVisible: false }
  }

  openGiftCardModal = () => {
    this.setState({ giftCardModalIsVisible: true })
  }

  closeGiftCardModal = () => {
    this.setState({ giftCardModalIsVisible: false })
  }

  render() {
    const {
      actionBox,
      playbackMessaging,
      notificationBox,
      playbackActions,
      downloadAction,
      trailerAction,
      purchaseAction,
      disneyAction,
      moreWaysToWatch,
      secondaryOfferMessage,
      ageVerification,
      purchaseDetails,
      pageTitleId,
      isRefunding,
      isDeeplinkableActionReady,
      useNodeGiftCard,
      requestContext
    } = this.props

    const isPurchasingMfa = Boolean(purchaseDetails)
    const isPurchasingAui = Boolean(actionBox && actionBox.main && actionBox.main.state === ActionBoxState.purchasing)

    const transactionText =
      (isPurchasingMfa &&
        purchaseDetails!.details &&
        purchaseDetails!.details!.offer.purchaseData.text) ||
      (isPurchasingAui && actionBox.main.purchasingText) ||
      ''
    const isProcessingTransaction =
      isPurchasingMfa || isPurchasingAui || isRefunding
    return (
      <div className={st.actionBox}>
        <div
          className={cn(
            {[st.isProcessingTransaction]: isProcessingTransaction},
            st.wrapper
          )}>
          <AdjustHeightForContent className={'dv-node-dp-action-box'}>
            <PlaybackMessaging {...playbackMessaging} />
            <AgeVerification {...ageVerification} />
            <Refund titleId={pageTitleId}/>
            <Spacer alignItems={spacerAlignItems.top}>
              <TextBlockNotification {...notificationBox} />
              {isDeeplinkableActionReady && playbackActions && <MultiplePlayback {...playbackActions} />}
              <Spacer
                alignItems={spacerAlignItems.top}
                className='avu-full-width-phablet'>
                {isDeeplinkableActionReady && trailerAction && <Trailer {...trailerAction} />}
                <Acquisition
                  {...purchaseAction}
                  tvodButtonScope={TvodButtonScope.ACTION_BOX}
                  forceDoubleHeight={true}
                />
                {moreWaysToWatch && (
                  <AtfMorePurchaseOptions {...moreWaysToWatch} openGiftCardModal={this.openGiftCardModal}/>
                )}
                <Watchlist isHover={false}/>
                <DisneyAction {...disneyAction} />
                {isDeeplinkableActionReady && downloadAction &&
                  (global.__NATIVEAPP__ ? (
                    <DownloadAction downloadInfo={downloadAction} withLabel/>
                  ) : (
                    <DownloadButtonWithLabel {...downloadAction} status={DownloadStatus.IDLE} forceDoubleHeight={true}/>
                  ))}
              </Spacer>
            </Spacer>
            <div className={Spacing.small}>
              <RedeemAndPromoLink placement={'ActionBox'} openGiftCardModal={this.openGiftCardModal}/>
              <SecondaryOfferMessage {...secondaryOfferMessage} />
            </div>
          </AdjustHeightForContent>
        </div>
        {isProcessingTransaction && (
          <TransactionOverlay text={transactionText}/>
        )}
        <PurchaseFailedModal/>
        {useNodeGiftCard && <GiftCardModal isOpen={this.state.giftCardModalIsVisible}
                                           onClose={this.closeGiftCardModal}
                                           requestContext={requestContext.rawContext}/>}
      </div>
    )
  }
}

const mapStateToProps = (state: IDetailPageState) => ({
  pageTitleId: state.pageTitleId,
  actionBox: state.actionBox,
  playbackMessaging: playbackMessagingComponentSelector(state),
  notificationBox: notificationActionsTextBlockMessagesSelector(state),
  playbackActions: multiplePlaybackComponentSelector(state),
  downloadAction: downloadComponentSelector(state),
  trailerAction: trailerComponentSelector(state),
  purchaseAction: purchaseComponentSelector(state),
  disneyAction: disneyComponentSelector(state),
  moreWaysToWatch: mwtwComponentSelector(state),
  secondaryOfferMessage: secondaryOfferMessageComponentSelector(state),
  ageVerification: ageVerificationSelector(state),
  purchaseDetails: purchaseSelector(state),
  isRefunding: Boolean(state.refund.refunding),
  isDeeplinkableActionReady: isDeeplinkableActionReadySelector(state),
  useNodeGiftCard: simpleSelectors.useNodeGiftCard(state),
  requestContext: sanitizedRequestContextSelector(state)
})

export const ActionBox = connect(mapStateToProps)(ActionBoxComponent)
